import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { FooterProps } from './types.js';

/** `<Footer>` component. */
export const Footer = ({
  children,
  className,
  isSelected,
  ...props
}: FooterProps): ReactElement => (
  <div
    className={twMerge(
      'flex h-28 items-center justify-between gap-8 px-8 text-sm text-muted transition group-hover:text-foreground',
      isSelected && 'text-foreground',
      className
    )}
    {...props}
  >
    {children}
  </div>
);
